/* istanbul ignore file */
import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ tabs: { tab, tabAddition, tabDark } }: ComposedTheme) => ({
  tab: {
    background: 'none',
    padding: 0,
    color: tab.color,
    border: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    '&:focus': {
      outlineColor: tab.focusColor,
    },
    '&:active': {
      outline: 'none',
    },
    ...tabAddition,
  },
  darkTab: {
    color: tabDark.color,
    '&:focus': {
      outlineColor: tabDark.darkFocusColor,
    },
  },
  selected: {
    color: tab.selectedColor,
  },
  darkSelected: {
    color: tabDark.color,
  },
});

export default createUseStyles(styles);
